import PropTypes from 'prop-types';

import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import {
  StyledList,
  StyledListItem,
  StyledListContainer,
  StyledTitle,
  StyledDescription,
  StyledBody
} from './AiSuggestionList.style';

const AiSuggestionList = ({
  items, titleReplacements, header, body
}) => (
  <StyledListContainer gap={4}>
    <Stack gap={2}>
      <Text
        fontWeight="medium"
        size="lg"
      >
        {header}
      </Text>
      <StyledList>
        {items?.map(({ description: itemDescription, title: itemTitle }) => (
          <StyledListItem
            divider
            key={`${itemTitle}`}
          >
            <Stack>
              <StyledTitle
                fontWeight="medium"
                size="sm"
              >
                {titleReplacements?.[itemTitle] || itemTitle}
              </StyledTitle>
              <StyledDescription
                fontWeight="regular"
                size="sm"
              >
                {itemDescription}
              </StyledDescription>
            </Stack>
          </StyledListItem>
        ))}
      </StyledList>
      {body && (
        <StyledBody
          fontWeight="regular"
          size="sm"
        >
          {body}
        </StyledBody>
      )}
    </Stack>
  </StyledListContainer>
);

AiSuggestionList.propTypes = {
  body: PropTypes.string,
  header: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string,
      title: PropTypes.string
    })
  ),
  titleReplacements: PropTypes.objectOf(PropTypes.string)
};

AiSuggestionList.displayName = 'AISuggestionList';

export default AiSuggestionList;
